export class OwnerNotificationsArchivePutRequest {
  ownerNotificationId!: string
  version!: number

  constructor(ownerNotificationId: string, version : number) {
    this.ownerNotificationId = ownerNotificationId
    this.version = version
  }
}
